'use strict';

var caseSensitiveTransform = require('./case-sensitive-transform');

module.exports = caseInsensitiveTransform;

function caseInsensitiveTransform(attributes, property) {
  return caseSensitiveTransform(attributes, property.toLowerCase());
}